import { render } from "./HealthnSafety.vue?vue&type=template&id=3e437a6e&scoped=true"
import script from "./HealthnSafety.vue?vue&type=script&lang=js"
export * from "./HealthnSafety.vue?vue&type=script&lang=js"

import "./HealthnSafety.vue?vue&type=style&index=0&id=3e437a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e437a6e"]])

export default __exports__